import { HierarchyReadDto } from "functions/api/hierarchy/HierarchyReadDto";
import { TitlesFootnotesReadDto } from "functions/api/tlfItem/TitlesFootnotesReadDto";
import { TlfItemReadDto } from "functions/api/tlfItem/TlfItemReadDto";
import { IUnifiedState } from "./interface";

/**
 * Domain data and variant selection that must move together through unified undo history.
 */
export interface IEditableData {
  tlfData: TlfItemReadDto | TitlesFootnotesReadDto | null;
  hierarchy: HierarchyReadDto | null;
  hierarchyNodes: HierarchyReadDto[];
  variant: Pick<
    IUnifiedState["tlfState"],
    "masterTlfData" | "appliedVariantPatches" | "activeVariantPatchName" | "variantCreationView"
  >;
}

/**
 * Selects complete domain objects without capturing statuses, settings, TOC or baselines.
 *
 * @param state - Unified application state.
 * @returns Editable domain data suitable for reversible JSON patches.
 */
export const toEditableData = (state: IUnifiedState): IEditableData => ({
  tlfData: state.tlfState.tlfData,
  hierarchy: state.hierarchyState.hierarchy,
  hierarchyNodes: state.hierarchyState.hierarchyNodes,
  variant: {
    masterTlfData: state.tlfState.masterTlfData,
    appliedVariantPatches: state.tlfState.appliedVariantPatches,
    activeVariantPatchName: state.tlfState.activeVariantPatchName,
    variantCreationView: state.tlfState.variantCreationView,
  },
});
